import {Box, SvgIcon, SvgIconProps, Typography} from "@mui/material";

export default function BelgiumTag(props: SvgIconProps) {
    const {viewBox, ...restProps} = props;
    return (
        <Box sx={{
            borderRadius: '50%',
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            height: '52px',
            width: '52px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            userSelect: 'none'
        }}>
            <Typography sx={{fontSize: '20px', fontWeight: 'bold', textAlign: 'center'}}>BE</Typography>
        </Box>
    );
}